export default "__VITE_ASSET__DtfCJ65P__"